const consenthubHosts = [
  'consenthub.utiq.com', // production env
  'consenthub.test.utiq-aws.net', // UAT env
  'consenthub.local.test.utiq-aws.net', // local env
];
export const isConsenthub = () => {
  const { host } = window.location;
  return consenthubHosts.includes(host);
};
